export function drRemoveLLCMsg(msgID: number, sid: string) {
    const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/purplusweb/llcRemoveMsg.asp?SessionID=${sid}&MsgID=${msgID}`;
    fetch(url,  {
        method: 'DELETE'
    }).then((res) => {
        if (res.ok) {
            res.json().then((resJson) => {
                if (resJson.ok) {
                    console.log("removed llc message");
                }
            })
        }
    });
}